import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-teilzeitwunsch',
    templateUrl: './checkbox-field.component.html'
} )
export class PartTimeFormComponent extends AbstractFieldComponent<boolean>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.parttime' );
    }

    set value( t: boolean | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.parttime = t;
        }
    }

    get value(): boolean | undefined {
        return this.jobapplication?.parttime;
    }
}
